import { AdminClientUsersListingItem, AdminClientUsersListingUser } from '@api/types/clientUsers';
import { Row } from '../../../../components/GenericTable/GenericTable';
import { ClientTableRow } from '../hooks/useClientsTable';

const mapUserToTableRow = (
  user: AdminClientUsersListingUser,
  company: AdminClientUsersListingItem,
  index: number,
): Row<ClientTableRow> => ({
  id: user.membershipGrantId || `${company.clientCode}-${index}`,
  rowType: 'user',
  company: company.companyName,
  user: user.email,
  role: user.companyRole,
  dashboards: '',
  dashboardAccess: user.dashboardAccess,
  totalEntitlementCount: user.dashboardAccess?.totalEntitlementCount,
  hasFullDashboardAccess: user.dashboardAccess?.hasFullAccess,
  joiningDate: user.joiningDate,
  status: user.status,
  clientCode: company.clientCode,
  membershipGrantId: user.membershipGrantId,
  userId: user.userId,
});

export const mapClientUsersToTableRows = (
  items: AdminClientUsersListingItem[],
): Row<ClientTableRow>[] =>
  items.map((company) => ({
    id: company.clientCode,
    rowType: 'company',
    company: company.companyName,
    user: `${company.userCount} User${company.userCount === 1 ? '' : 's'}`,
    role: null,
    dashboards: '',
    totalEntitlementCount: company.totalEntitlementCount,
    hasFullDashboardAccess: false,
    joiningDate: '-',
    status: '-',
    clientCode: company.clientCode,
    children: company.users.map((user, index) => mapUserToTableRow(user, company, index)),
  }));
